import React, { useState } from "react";
import R from "ramda";
import PropTypes from "prop-types";
import isTouchDevice from "is-touch-device";
import pluralize from "pluralize";
import { Button } from "@material-ui/core";
import { NavLink } from "react-router-dom";

import { useScreen, useTemplateGroupTracking } from "hooks";
import Placeholder from "components/Placeholder";
import StarringYouPresenter from "presenters/StarringYouPresenter";
import { appRoutes } from "routes";
import LazyLoad from "components/LazyLoad";

import useStyles from "./useStyles";

const StarringYou = ({ item, lazy, loading = false }) => {
  const classes = useStyles();
  const { isMobile } = useScreen();
  const { trackClick } = useTemplateGroupTracking(item);
  const [overlayVisible, setOverlayVisible] = useState(false);

  const handleMouseEnter = (e) => {
    if (isTouchDevice()) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    setOverlayVisible(true);
  };

  const handleMouseLeave = () => {
    setOverlayVisible(false);
  };

  const handleClick = (e) => {
    if (isTouchDevice() && !overlayVisible) {
      e.preventDefault();
      e.stopPropagation();
      setOverlayVisible(true);
      return false;
    }

    return trackClick();
  };

  const renderCastOptions = (castNumOptions) => {
    const max = R.last(castNumOptions);
    const min = castNumOptions[0];

    if (max !== min) {
      return (
        <>
          {min} to {max} <br /> People
        </>
      );
    }

    return (
      <>
        {min} <br /> {pluralize("Person", min)}
      </>
    );
  };

  if (loading)
    return (
      <div className={classes.card}>
        <Placeholder variant="rect" ratio="4x6" />
      </div>
    );

  return (
    <NavLink to={appRoutes.templateGroupPath(StarringYouPresenter.id(item))} onClick={handleClick}>
      <div
        role="presentation"
        className={classes.card}
        onMouseEnter={handleMouseEnter}
        onFocus={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onBlur={handleMouseLeave}
        onClick={handleClick}
      >
        {StarringYouPresenter.thumb(item) && (
          <LazyLoad lazy={lazy}>
            <img
              src={StarringYouPresenter.thumb(item)}
              alt={StarringYouPresenter.name(item)}
              className={classes.cardImg}
            />
          </LazyLoad>
        )}
        {overlayVisible && (
          <div className={classes.overlay}>
            <div className={classes.overlayText}>{renderCastOptions(StarringYouPresenter.castNumOptions(item))}</div>
            <Button className={classes.overlayBtn} variant="contained" size={isMobile ? "small" : "medium"}>
              GET STARTED
            </Button>
          </div>
        )}
      </div>
    </NavLink>
  );
};

StarringYou.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    attributes: PropTypes.shape({}),
  }),
  lazy: PropTypes.bool,
  loading: PropTypes.bool,
};

export default StarringYou;
